export default __webpack_public_path__ + "static/media/mainLogo.90cb7e58.svg";